import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementPlus from "element-plus";
import "element-plus/dist/index.css";
import "@/assets/styles/border.css";
import "@/assets/styles/reset.css";// 引入全局样式
import "@/router/permission.js";// 引入路由权限控制
import * as ElementPlusIconsVue from "@element-plus/icons-vue";
import zhCn from 'element-plus/es/locale/lang/zh-cn'// 引入中文语言包
import "dayjs/locale/zh-cn"; // 引入 dayjs 的中文语言包
import { checkUpdateMsg } from "@/util/useUpdate";// 检查更新提示
import api from "@/util/api";// 引入全局 api 方法
import code from "@/config/codeConfig"; //状态码
import print from 'vue3-print-nb' // 引入打印插件
import { quillEditor, Quill } from "vue3-quill"; // 引入vue3 富文本组件
 
// import customQuillModule from 'customQuillModule' // 自定义富文本模块
// Quill.register('modules/customQuillModule', customQuillModule)

const app = createApp(App);
app.use(ElementPlus, { locale: zhCn });
app.use(print)
app.provide("$api", api); // 提供全局引用 api 方法
app.provide("$code", code); // 提供全局引用 code 状态码
app.provide("pageSize", [10, 20, 30, 50, 100, 200, 500, 1000, 2000]); // 表格页码
app.use(quillEditor); // 使用富文本
app.use(store).use(router);

/**自定义全局按钮权限指令 */
app.directive("z-auth", {
  // 指令的定义对象
  beforeMount(el, binding, vnode) {
    // `el` 是指令绑定的 DOM 元素
    // `binding` 是指令的绑定信息
    // `vnode` 是虚拟 DOM 节点
    const auth = binding.value; // 获取绑定的值
    const authString = store.getters.GET_AUTHSTRING(auth); // 从 store 获取权限字符串

    // 在这里可以进行权限验证逻辑
    // console.log({ el });
    if (authString !== true) {
      el.style.display = "none"; // 例如，隐藏没有权限的元素
    }
  },
});

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}// 注册 Element Plus 图标组件
checkUpdateMsg();
// 打开页面时 判断下上此设置的主题 获取 <html> 标签
const htmlElement = document.documentElement;
if (store.state.themeConfig.themes === "dark") {
  htmlElement.classList.add("dark");
} else {
  // console.log("移除", "dark");
  htmlElement.classList.remove("dark");
}

/**
 * 运行时加载 public/config.json，根据部署环境动态设置 baseUrlIndex
 * 打包一次即可部署到不同服务器，只需在各服务器上修改 config.json 中的 baseUrlIndex
 * config.json 位于 dist 根目录（由 public/ 拷贝），部署后可直接用文本编辑器修改   
 * 弊端 fetch 读取 config.json 是异步的，可能会导致页面渲染时 baseUrlIndex 还没加载完，导致请求接口失败
 * 解决方法：在 main.js 中使用 async/await 读取 config.json，等读取完再挂载 app
 * 但这样会导致页面加载时有短暂的白屏，用户体验不好
 * 所以暂时不使用异步加载 config.json，而是直接在代码中设置 baseUrlIndex
 * 如果需要动态修改 baseUrlIndex，请在部署后手动修改 config.json 并刷新页面
 */
// async function loadRuntimeConfig() {
//   try {
//     // 加时间戳防止浏览器缓存旧的 config.json
//     const res = await fetch((process.env.BASE_URL || "./") + "config.json?t=" + Date.now());
//     const config = await res.json();
//     if (config && typeof config.baseUrlIndex === "number") {
//       store.commit("SET_BASEURL_INDEX", config.baseUrlIndex);
//       console.log("运行时配置 baseUrlIndex =", config.baseUrlIndex);
//     }
//   } catch (e) {
//     console.warn("加载 config.json 失败，使用默认 baseUrlIndex=0:", e.message);
//   }
// }

// loadRuntimeConfig().finally(() => {
  app.mount("#app");
// });
